/**
 * API Error Utility
 * Reads the error message the server sent with a non-2xx response.
 *
 * Use this only for endpoints whose success response is not JSON (file
 * downloads, SSE streams). For plain JSON endpoints, read the body with
 * response.json() and show data.error directly.
 */

/**
 * Extract the server's error message from a failed response.
 *
 * @param {Response} response - A fetch response with a non-2xx status
 * @returns {Promise<string>} The server's message, or the status when the body is not JSON
 */
export async function readApiError(response) {
  const contentType = response.headers.get('content-type') || '';

  if (!contentType.includes('application/json')) {
    return `Request failed (HTTP ${response.status})`;
  }

  const data = await response.json();
  return data.error || data.details || `Request failed (HTTP ${response.status})`;
}
